import { defineMessages } from 'react-intl';

import { Urls } from './Urls';

export const FooterMessages = defineMessages({
  about: {
    id: 't.about',
    defaultMessage: 'About',
  },
  adPreferences: {
    id: 't.adPreferences',
    defaultMessage: 'Ad Preferences',
  },
  advertising: {
    id: 't.advertising',
    defaultMessage: 'Advertising',
  },
  blog: {
    id: 't.blog',
    defaultMessage: 'Blog',
  },
  businesses: {
    id: 't.businesses',
    defaultMessage: 'Businesses',
  },
  community: {
    id: 't.community',
    defaultMessage: 'Community',
  },
  cookieSettings: {
    id: 't.cookieSettings',
    defaultMessage: 'Cookie Settings',
  },
  copyright: {
    id: 't.copyright',
    defaultMessage:
      '© {date} Pandora Media, LLC, All Rights Reserved. Pandora and the Music Genome Project are registered trademarks of Pandora Media, LLC.',
  },
  doNotSell: {
    id: 't.doNotSell',
    defaultMessage: 'Do Not Sell My Personal Information',
  },
  forArtist: {
    id: 't.forArtists',
    defaultMessage: 'For Artists',
  },
  gifts: {
    id: 't.gifts',
    defaultMessage: 'Gifts',
  },
  help: {
    id: 't.help',
    defaultMessage: 'Help',
  },
  investor: {
    id: 't.investor',
    defaultMessage: 'Investor',
  },
  jobs: {
    id: 't.jobs',
    defaultMessage: 'Jobs',
  },
  privacy: {
    id: 't.privacy',
    defaultMessage: 'Privacy',
  },
  signUp: {
    id: 't.signUp',
    defaultMessage: 'Sign up to start listening for free.',
  },
  signUpNow: {
    id: 't.signUpNow',
    defaultMessage: 'Sign Up Now',
  },
  terms: {
    id: 't.terms',
    defaultMessage: 'Terms',
  },
  yourPrivacyChoices: {
    id: 't.yourPrivacyChoices',
    defaultMessage: 'Your Privacy Choices',
  },
} as const);

export const footerNavLinks = [
  [FooterMessages.about, `${Urls.ABOUT}`],
  [FooterMessages.jobs, `${Urls.CAREERS}`],
  [FooterMessages.advertising, `${Urls.ADVERTISING}`],
  [FooterMessages.businesses, `${Urls.BUSINESS}`],
  [FooterMessages.forArtist, `${Urls.AMP}`],
  [FooterMessages.investor, `${Urls.INVESTOR}`],
  [FooterMessages.blog, `${Urls.BLOG}`],
  [FooterMessages.gifts, `${Urls.GIFTS}`],
  [FooterMessages.privacy, `${Urls.PRIVACY}`],
  [FooterMessages.terms, `${Urls.TERMS}`],
  [FooterMessages.help, `${Urls.HELP}`],
  [FooterMessages.community],
  [FooterMessages.adPreferences, `${Urls.ADVERTISING_PREFERENCES}`],
  [FooterMessages.doNotSell],
  [FooterMessages.yourPrivacyChoices, `${Urls.PRIVACY_CHOICES}`],
  [FooterMessages.cookieSettings],
] as const;
